/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum InsurancePaymentOptionListing {
  Personal = "personal",
  Employer = "employer",
  Extranet = "extranet",
  ExtranetEmployer = "extranet_employer",
}

/** Types of suggestions to search for. */
export enum SearchAppointmentSuggestionType {
  Location = "location",
  Node = "node",
  Date = "date",
}

/** Gender to filter specialists by. */
export enum Gender {
  M = "M",
  F = "F",
}

/** Time ranges to filter results by. */
export enum TimeRange {
  Morning = "morning",
  Afternoon = "afternoon",
  Evening = "evening",
}

export enum ContractRuleStatus {
  Allowed = "allowed",
  Disallowed = "disallowed",
  Restriction = "restriction",
  ReferralRequired = "referral_required",
  AssessmentRequired = "assessment_required",
  PaymentCommitmentAllowed = "payment_commitment_allowed",
  PaymentCommitmentDisallowed = "payment_commitment_disallowed",
  CompanyInsurance = "company_insurance",
  DentalRestriction = "dental_restriction",
  BookingPermitAllowed = "booking_permit_allowed",
}

export enum AppointmentSource {
  DH = "DH",
  AssisDent = "AssisDent",
}

export enum ReservationDestinationSystem {
  Dh = "dh",
  Assisdent = "assisdent",
  Docrates = "docrates",
}

export enum BookingNavigation {
  None = "none",
  Docrates = "docrates",
  DocratesAdvancePayment = "docrates_advance_payment",
}

export enum AppointmentType {
  Video = "video",
  Phone = "phone",
  Clinic = "clinic",
  Callback = "callback",
}

export enum ReservationPaymentType {
  Self = "self",
  HealthContract = "health_contract",
  Synsam = "synsam",
  ServiceVoucher = "service_voucher",
  GiftCard = "gift_card",
  PhysiotherapyReferral = "physiotherapy_referral",
  Occupational = "occupational",
  Insurance = "insurance",
  Other = "other",
}

export enum SourceService {
  APP = "APP",
  OM = "OM",
  MDAV = "MDAV",
  MDAV_DH_NAPPI = "MDAV_DH_NAPPI",
  MDAV_DH_VIDEO = "MDAV_DH_VIDEO",
}

/** Linking type (etns for now). */
export enum SearchNodeLinkingType {
  Etns = "etns",
  NEtns = "n_etns",
  Palv = "palv",
  Apalv = "apalv",
  Oa = "oa",
  Reason = "reason",
  ParseKey = "parse_key",
}

export enum NodeFeature {
  SpecialistAppointmentListDisabled = "specialistAppointmentListDisabled",
  AgeCheckEnabled = "ageCheckEnabled",
}

export enum NodeType {
  Default = "default",
  ServicePackage = "service_package",
}

export enum NotificationLinkType {
  Button = "button",
  InlineLink = "inline-link",
}

export enum NotificationStyle {
  Raise = "raise",
  Info = "info",
  WalkIn = "walk-in",
  Error = "error",
  Warning = "warning",
}

export enum NotificationPlacement {
  TopOfSearch = "top_of_search",
  SearchResultsTop = "search_results_top",
  SearchResultsWithin = "search_results_within",
}

export enum NodeServiceType {
  Private = "private",
  Ohc = "ohc",
  Both = "both",
}

export enum ElectronicHealthRecordSystem {
  Dh = "dh",
  Assisdent = "assisdent",
}

export enum SupportedLanguage {
  Fi = "fi",
  En = "en",
  Sv = "sv",
}

export enum LocationType {
  All = "all",
  City = "city",
  Region = "region",
  Clinic = "clinic",
}

export interface ServiceAttachment {
  title: string;
  link: string;
}

export interface BookingInstructions {
  bookingInstructions: string;
  attachments?: ServiceAttachment[];
}

export interface LocationResult {
  type: LocationType;
  id: number;
  uniqueId: string;
  /** DH clinic IDs */
  clinicIDs: string[];
  assisDentBranchIDs: string[];
  name: string;
  address: string | null;
  shortName: string | null;
  phone: string | null;
  imageUrl: string | null;
  lat: number | null;
  long: number | null;
  clinicType: string;
  priority: number;
  favorite: boolean;
  locationTypes: number[];
  defaultNode?: string | null;
  isPublic: boolean;
  city_id?: number | null;
  region_id?: number | null;
}

export interface LanguageResult {
  /** ID of the language */
  id: number;
  /** @example "suomi" */
  language: string;
}

export interface PatientAgeGroup {
  /**
   * ID of the age group.
   * @example 1
   */
  id: number;
  /** Translated description of the age group. */
  patientAgeGroup: string;
}

export interface PriceEstimate {
  /** Service id for which the price estimate is formed. */
  serviceId: number;
  /** Name of the service, translated. */
  name: string;
  /**
   * Minimum price estimate of the service.
   * @example 110.5
   */
  minPrice: number;
  /**
   * Maximum price estimate of the service.
   * @example 150
   */
  maxPrice: number;
  /** Whether the appointment duration affects the price estimate. */
  durationAffectsPrice: boolean;
}

export interface Competence {
  /**
   * Competence ID.
   * @example 124
   */
  id: number;
  /**
   * Competence type. Maps to CompetenceType enum.
   * @example 1
   */
  type: 1 | 2 | 3 | 4 | 5 | 6;
  /** Translated competence as a string. */
  competence: string;
  /**
   * Year when competence achieved, e.g. a completion year of a degree.
   * @example 1990
   */
  year?: number;
}

export interface PractitionerLocation {
  /**
   * Location identifier.
   * @example "T-25"
   */
  id: string;
  /**
   * Name of the location.
   * @example "Kielotie"
   */
  name: string;
}

export interface PractitionerLanguage {
  /**
   * Language name, translated.
   * @example "ruotsi"
   */
  language: string;
  /**
   * Language skill level, translated.
   * @example "työkieli"
   */
  level: string;
}

export interface PatientRestriction {
  /**
   * ID of the restriction.
   * @example 9
   */
  id: number;
  /** Translated description of the restriction. */
  patientRestriction: string;
}

export interface AppointmentLengthOption {
  /**
   * Duration of the option, in minutes.
   * @example 40
   */
  duration: number;
  /**
   * Translated descriptions of the option.
   * @example ["Ajokorttitodistukset ja muut todistukset","Kattavammat lausunnot"]
   */
  description: string[];
  /**
   * Name of the service.
   * @example "Urheiluhieronta"
   */
  serviceName?: string;
  /**
   * (Palveluhaku) ID of the service.
   * @example 1
   */
  serviceId?: number;
}

export interface FlexibleScheduleOption {
  /**
   * (Palveluhaku) ID of the service.
   * @example 563
   */
  serviceId: number;
  /**
   * ID of the location.
   * @example "clinic_443"
   */
  locationId: string;
  /**
   * (DH) ID of the location.
   * @example "M-24"
   */
  locationDHId: string;
  /**
   * Name of the service.
   * @example "Kinesioteippaus"
   */
  serviceName: string;
  /**
   * List of available durations for this service.
   * @example [45,60]
   */
  availableDurations: number[];
  /**
   * List of ETNS (specialties) for this service.
   * @example ["YLE","SIL"]
   */
  etns?: string[];
}

export interface PractitionerNode {
  serviceType: NodeServiceType;
  id: string;
  name: string;
}

export interface AssisDentReason {
  id: string;
  name: string;
  nodeId: string;
}

export interface PractitionerDetails {
  primarySource: ElectronicHealthRecordSystem;
  title: string;
  image?: string;
  rating?: number;
  introduction?: string;
  bookingInstructions?: string;
  testimonial?: string;
  hasFlexibleSchedule?: boolean;
  priceEstimates: PriceEstimate[];
  competencies: Competence[];
  locations: PractitionerLocation[];
  nearFutureLocations: PractitionerLocation[];
  languages: PractitionerLanguage[];
  patientRestrictions: PatientRestriction[];
  patientAgeGroups: PatientAgeGroup[];
  appointmentLengthOptions: AppointmentLengthOption[];
  flexibleScheduleOptions: FlexibleScheduleOption[];
  insuranceContractIds: number[];
  isEntrepreneur: boolean;
  isEmployee: boolean;
  allowsCallbackReservations: boolean;
  nodes: PractitionerNode[];
  assisDentEmployeeId?: string;
  assisDentReasons?: AssisDentReason[];
  isAssisDentMaintenance?: boolean;
  id: number;
  name: string;
}

export interface NotificationLinkList {
  link: string;
  linkText: string;
}

export interface SimpleNotification {
  placements: NotificationPlacement[];
  style: NotificationStyle | null;
  linkType: NotificationLinkType | null;
  isInternalLink: boolean;
  linkText: string | null;
  linkList?: NotificationLinkList[];
  /** @format uuid */
  id: string;
  title: string | null;
  content: string | null;
  icon: string | null;
  link: string | null;
  showRegularAppointments: boolean;
  showVideoAppointments: boolean;
  showPhoneAppointments: boolean;
  searchCountRestrictions: number | null;
}

export interface DCNotification {
  placements: NotificationPlacement[];
  queueLength: number;
  queueId: string;
  ctaText: string;
  /** @format uuid */
  id: string;
  title: string | null;
  content: string | null;
  icon: string | null;
  link: string | null;
  showRegularAppointments: boolean;
  showVideoAppointments: boolean;
  showPhoneAppointments: boolean;
  searchCountRestrictions: number | null;
}

export interface ServiceDetails {
  id: number;
  name: string;
  bookingInstructions?: string;
}

export interface DateRange {
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string | null;
}

export interface ContractUsePeriods {
  dates: DateRange[];
  /** @format date-time */
  employmentStarts: string;
  isPaymentCommitmentRequired: boolean;
  userPaymentCommitmentDates: DateRange[];
  namedCheckupOfficeCityId: number;
  isOnlineReservationAllowed: boolean;
}

export interface FeatureFlag {
  name: string;
  value: boolean;
}

export interface PricingItem {
  type: "hinnastoryhma" | "hinnastokoodi";
  value: string;
  parentGroup: string | null;
  isRemote: boolean;
  operator: "and" | "or" | null;
  order: number | null;
}

export interface ContractItem {
  code: number;
}

export interface SearchNodeService {
  connectionId: string;
  modal: string | null;
  modalOhc: string | null;
  serviceId: string;
  term: string;
  termType:
    | "specialty"
    | "lkri"
    | "expertise"
    | "service"
    | "service_package"
    | "node"
    | "age_group"
    | "reason";
  compensationGroupLevel1: boolean;
  compensationGroupLevel2: boolean;
  compensationGroupLevelOther: boolean;
  pricingItems: PricingItem[];
  remotePricingItems: PricingItem[];
  contractItems: ContractItem[];
  ignoreContractConfirmation: boolean;
  referralRequirementForOHC: "contract" | "always" | "never";
  referralRequiredForPrivateCustomers: boolean;
  dentalContractRestriction: boolean;
}

export interface SearchNodeConnectionCondition {
  id: string;
  propertyPath: string;
  propertyValue: string;
  propertyDataType: string;
  operator: string;
}

export interface SearchNodeTerm {
  id: string;
  type:
    | "specialty"
    | "lkri"
    | "expertise"
    | "service"
    | "service_package"
    | "node"
    | "age_group"
    | "reason";
  term: string;
  freedomOfChoice?: boolean;
}

export interface SearchNodeConnection {
  id: string;
  services?: SearchNodeService[];
  nodeId?: string;
  conditions: SearchNodeConnectionCondition[];
  priority: number;
  type: "dh" | "assisdent";
  terms: SearchNodeTerm[];
  practitionerRestriction: "named_practitioners" | "all_practitioners" | null;
}

export interface SearchNodeWithModals {
  type: NodeType;
  features?: NodeFeature[];
  serviceType: NodeServiceType;
  children?: SearchNodeWithModals[];
  privateCustomerModalId: string;
  ohcPrimaryModalId: string;
  ohcSubstituteModalId: string;
  ohcInterception?: {
    coverage:
      | "allowed"
      | "disallowed"
      | "restriction"
      | "referral_required"
      | "assessment_required"
      | "payment_commitment_allowed"
      | "payment_commitment_disallowed"
      | "company_insurance"
      | "dental_restriction"
      | "booking_permit_allowed";
    allowedForEmployee: boolean;
  };
  reservable: boolean;
  action: "reservation_blocked" | null;
  servicePackageServiceId?: number;
  /** @deprecated */
  remote: boolean;
  showRegardlessOfContract?: boolean;
  showBeforeEmploymentBegins?: boolean;
  connections?: SearchNodeConnection[];
  /** @format uuid */
  id: string;
  name: string;
  descriptionTitle?: string;
  description?: string;
  title?: string;
  caption?: string;
  icon?: string;
  /** @format uuid */
  parentId?: string;
  parentName?: string;
  locationTypes: number[];
  video: boolean;
  phone: boolean;
  redirect?: string;
  /** @format uuid */
  modalId?: string;
  priority: number | null;
  referralLinks: string[];
  isFavorite?: boolean;
  favoriteOrder?: number;
  isListed?: boolean;
}

export interface SearchNodeConnectionBase {
  priority: number;
  type: "dh" | "assisdent";
  terms: SearchNodeTerm[];
  practitionerRestriction: "named_practitioners" | "all_practitioners" | null;
}

export interface PublicNode {
  type: NodeType;
  features?: NodeFeature[];
  children?: PublicNode[];
  /** @format uuid */
  id: string;
  name: string;
  descriptionTitle?: string;
  description?: string;
  title?: string;
  caption?: string;
  icon?: string;
  /** @format uuid */
  parentId?: string;
  parentName?: string;
  locationTypes: number[];
  video: boolean;
  phone: boolean;
  redirect?: string;
  /** @format uuid */
  modalId?: string;
  priority: number | null;
  connections?: SearchNodeConnectionBase[];
  referralLinks: string[];
  isFavorite?: boolean;
  favoriteOrder?: number;
  isListed?: boolean;
}

export interface SearchNodeLinking {
  /** Linking type (etns for now). */
  type: SearchNodeLinkingType;
  numericId: number | null;
  textualId: string | null;
  /**
   * Guid of the node used for searching.
   * @format uuid
   */
  node: string;
  /**
   * Guid for the OHC node used for mapping OHC requets
   * @format uuid
   */
  ohcNode: string | null;
  /** @format uuid */
  modalId: string | null;
  modalAction: string | null;
}

export interface ModalAction {
  title: string;
  /** @format uuid */
  id: string;
  appearance: "primary" | "secondary" | "tertiary";
  type: "close" | "continue" | "digital_clinic" | "node" | "url";
  queue: string | null;
  /** @format uuid */
  node: string | null;
  url: string | null;
}

export interface Modal {
  title: string;
  content: string | null;
  actions: ModalAction[];
  /** @format uuid */
  id: string;
  name: string;
  type:
    | "referral"
    | "referral_tep"
    | "restriction"
    | "not_included"
    | "assessment_required"
    | "payment_commitment_invalid"
    | "payment_commitment_valid"
    | "company_insurance"
    | "own_team"
    | "node"
    | "dental_tep"
    | "om_feature_option"
    | "freedom_of_choice_enabled"
    | "freedom_of_choice_disabled"
    | "freedom_of_choice_redirect"
    | "continuous_care_restriction";
  default: boolean;
  internalDescription: string | null;
}

export interface Address {
  postalCode: string;
  address: string;
  postOffice: string;
}

export interface MarketingPermits {
  permitPhone: boolean;
  permitEmail: boolean;
}

export interface OccupationalAccidentInformation {
  /** @format date-time */
  incidentDate: string;
  /** @maxLength 60 */
  incidentDescription: string;
  /** @maxLength 40 */
  employer: string;
}

export interface TrafficAccidentInformation {
  /** @format date-time */
  incidentDate: string;
  /** @maxLength 60 */
  incidentDescription: string;
  /** @maxLength 10 */
  vehicleRegistrationNumber: string;
}

export interface AccidentDetailsFormData {
  id: string;
  required: boolean;
  value: string;
}

export interface DirectCompensationInformation {
  permitId: string;
  userFormData?: AccidentDetailsFormData[];
}

export interface ReserveInsurance {
  insuranceId: number;
  /** @format uuid */
  paymentTypeId: string;
  occupationalAccidentInformation?: OccupationalAccidentInformation;
  trafficAccidentInformation?: TrafficAccidentInformation;
  directCompensationInformation?: DirectCompensationInformation;
}

export interface ReserveParams {
  /** @default "fi" */
  lang?: SupportedLanguage;
  /**
   * The appointment ID. Either DH PTR as a number or internal AssisDent id as a string.
   * @example 1234
   */
  appointmentId: string | number;
  sourceService?: SourceService;
  paymentType?: ReservationPaymentType;
  /** @maxLength 35 */
  firstName: string;
  /** @maxLength 35 */
  lastName: string;
  ssn: string;
  /**
   * Internal flag set by MdavClientFlagMiddleware.
   * Used for conditional validation of phone and email fields.
   * Always overwritten by the middleware - user-supplied values are ignored.
   * Excluded from responses only (toPlainOnly) so it can be read during validation.
   */
  _isMdavClient?: boolean;
  /**
   * Email is required for non-MDAV requests.
   * For MDAV requests, email is optional unless contactByEmail is true.
   * @format email
   * @maxLength 100
   */
  email?: string;
  /**
   * Phone is required for non-MDAV requests.
   * For MDAV requests, phone is optional unless contactBySms is true.
   */
  phone?: string;
  /** Phone appointment number for MDAV requests as there is a dedicated field for it. */
  phoneAppointmentNumber?: string;
  /** @format uuid */
  nodeId?: string;
  /** @format uuid */
  connectionId?: string;
  serviceId?: number;
  specialtyId?: number;
  /**
   * @maxLength 400
   * @default ""
   */
  appointmentReason: string;
  appointmentType: "video" | "phone" | "clinic" | "callback";
  /** @default false */
  isFromApp?: boolean;
  /** @default false */
  isFromOM?: boolean;
  /** @default true */
  sendAttachments?: boolean;
  /** @default true */
  contactByEmail?: boolean;
  /** @default true */
  contactBySms?: boolean;
  minorDisclosureOfInformation?: boolean;
  duration?: number;
  registration?: Address;
  marketingPermits?: MarketingPermits;
  serviceMessagePermit?: boolean;
  insurance?: ReserveInsurance;
  reserveToOmUid?: number;
  discountCode?: string;
  isOhc?: boolean;
  customerNotes?: string;
  paymentNotes?: string;
  selfServiceRestriction?: boolean;
  careChainId?: number;
}

export interface ReserveResult {
  /**
   * The appointment ID. Either DH PTR as a number or AssisDent id as a string.
   * @example 1234
   */
  appointmentId: string | number;
  /** Identifier of the created reservation. */
  reservationId: string;
  /** Status message */
  message: string;
  /** Status message */
  videoAppointmentUrl?: string;
}

export interface CancelAppointmentParams {
  /** @default "fi" */
  lang?: SupportedLanguage;
  reservationId: string;
}

export interface CancellationInfo {
  appointmentType: AppointmentType;
  locationName?: string;
  locationAddress?: string;
  locationPostalCode?: string;
  locationPostalDistrict?: string;
  bookingNavigation?: string;
  /** @format date-time */
  time: string;
  duration: number;
}

export interface AppointmentReservationInfo {
  type: AppointmentType;
  bookingNavigation: BookingNavigation;
  electronicHealthRecordSystem: "dh" | "assisdent";
  assisdentId?: string;
  /**
   * Date and time of the appointment.
   * @format date-time
   */
  time: string;
  /** Duration of the appointment in minutes. */
  duration: number;
  /** Translated name of the location. */
  locationName: string;
  /** Translated location address. */
  locationAddress: string;
  /** Postal code of the location. */
  locationPostalCode: string;
  /** Postal district of the location. */
  locationPostalDistrict: string;
  locationCoordinates: {
    lat: number | null;
    long: number | null;
  };
  /** Location id. */
  locationId: string;
  /** First and last name of the specialist. */
  specialistName: string;
  /** The translated specialist's title. */
  specialistTitle: string;
  /**
   * A media.mehilainen.fi resource.
   * @example "945979dbf6854066f9e2b19262e8909d.jpg"
   */
  image: string | null;
  /** The translated arrival info. */
  arrivalInfo: string | null;
  /** The translated parking info. */
  parkingInfo: string | null;
  /**
   * Title of the appointment, resolved from the node
   * through which the reservation was made.
   *
   * If no node was used during reservation, this is null.
   */
  appointmentTitle: string | null;
  /** Is the practitioner resource list (RNRO = 50). */
  isResourceList: boolean;
  practitionerId: number;
  minorDisclosureOfInformationForbidden: boolean;
}

export interface UUIDOrIntPipeResult {
  uuid: string | null;
  number: number | null;
}

export interface ReservationPaymentTypesResponse {
  paymentTypes: ReservationPaymentType[];
}

export interface CallbackReservationAllowedParams {
  /**
   * The appointment ID. Either DH PTR as a number or internal AssisDent id as a string.
   * @example 1234
   */
  appointmentId: string | number;
  ssn: string;
  reserveToOmUid?: number;
  isOhc?: boolean;
}

export interface CallbackAllowedResponse {
  callbackAllowed: boolean;
}

export interface ReservationDestinationSystemResult {
  destinationSystem: ReservationDestinationSystem;
}

export interface AppointmentInfoResult {
  /**
   * The appointment ID. Either DH PTR as a number or AssisDent id as a string.
   * @example 1234
   */
  id: string | number;
  appointmentSource: AppointmentSource;
  ohcClinicAppointmentRule?: ContractRuleStatus;
  ohcVideoAppointmentRule?: ContractRuleStatus;
  ohcPhoneAppointmentRule?: ContractRuleStatus;
  /**
   * The LocationResult.uniqueId for this appointment (e.g. "clinic338"). Can be used directly as the locationIds search filter value.
   * @example "clinic338"
   */
  searchLocationId?: string;
  etns: string | null;
  etnsA: string | null;
  etnsB: string | null;
  practitionerDhId: string | null;
  practitionerHasFlexibleSchedule: boolean;
  isClinicAppointmentPermitted: boolean;
  isVideoAppointmentPermitted: boolean;
  isPhoneAppointmentPermitted: boolean;
  /** Is the practitioner resource list (RNRO = 50). */
  isResourceList: boolean;
  isCallbackAppointment: boolean;
  isWebAppointment: boolean;
  roomDirections?: string | null;
  /** @format date-time */
  date: string;
  duration: number;
  practitionerId: number;
  practitionerName: string;
  practitionerTitle: string;
  practitionerImage: string;
  locationId: string;
  locationName: string;
  locationAddress: string;
  locationPostplace: string;
  locationPostnumber: string;
}

export interface TimeRangeInput {
  /**
   * @min 0
   * @max 23
   */
  start: number;
  /**
   * @min 0
   * @max 24
   */
  end: number;
}

export interface SearchNodeAppointmentsParams {
  /**
   * Time ranges to filter results by.
   * @uniqueItems true
   * @example ["morning","afternoon","evening"]
   */
  timeRanges?: TimeRange[];
  /** @default "fi" */
  lang?: SupportedLanguage;
  /** Gender to filter specialists by. */
  gender?: Gender;
  /**
   * Appointment types to return.
   * @example ["video","phone"]
   */
  appointmentTypes?: AppointmentType[];
  /**
   * Guid of the node used for searching.
   * @format uuid
   */
  id: string;
  /**
   * Startdate for the search.
   * @format date-time
   */
  startDate: string;
  /**
   * @min 1
   * @max 6
   */
  nroOfMonths?: number;
  /**
   * Locations to filter results by.
   * @minItems 1
   * @example ["city2","clinic338"]
   */
  locationIds: string[];
  /**
   * LocationIds converted to internal location ids.
   * @example ["B-11","DOC","E-99","F-21"]
   */
  internalLocationIds?: string[];
  timeRange?: TimeRangeInput;
  durations?: number[];
  /** Patient age group ID to filter specialists by. */
  patientAgeGroupId?: number;
  /** Language ID to filter specialists by. */
  languageId?: number;
  /**
   * Insurance contract ID (Palveluhaku) to filter appointments by.
   * @example 1
   */
  insuranceContractId?: number;
  /** Is this OHC appointment search? */
  isOHC?: boolean;
  offset?: number;
}

export interface ModalContractCondition {
  /** @format uuid */
  id: string;
  numericValue: number | null;
  textualValue: string | null;
  type: "contract_row" | "other";
  action: "skip" | "redirect";
  redirect: string | null;
}

export interface ModalWithContractConditions {
  title: string;
  content: string | null;
  actions: ModalAction[];
  /** @format uuid */
  id: string;
  name: string;
  type:
    | "referral"
    | "referral_tep"
    | "restriction"
    | "not_included"
    | "assessment_required"
    | "payment_commitment_invalid"
    | "payment_commitment_valid"
    | "company_insurance"
    | "own_team"
    | "node"
    | "dental_tep"
    | "om_feature_option"
    | "freedom_of_choice_enabled"
    | "freedom_of_choice_disabled"
    | "freedom_of_choice_redirect"
    | "continuous_care_restriction";
  default: boolean;
  internalDescription: string | null;
  contractCondition: ModalContractCondition | null;
}

export interface AssisDentSearchResult {
  id: string;
  /** @format uuid */
  branchId: string;
  /** @format uuid */
  resourceId: string;
  /** @format uuid */
  reasonId: string;
  /** @format date-time */
  startTime: string;
  /** @format date-time */
  endTime: string;
  length: number;
}

export interface AppointmentSearchResult {
  /** Is the appointment covered by the OHC contract */
  isCoveredByOHC?: ContractRuleStatus;
  /**
   * Date and time of the appointment.
   * @format date-time
   */
  time: string;
  /** Duration of the appointment in minutes. */
  duration: number;
  /** Location of the appointment. */
  location: string;
  /** Numeric ID of the location. */
  locationId?: number;
  /** Translated name of the location. */
  locationName: string;
  locationShortName?: string;
  /** Translated location address. */
  locationAddress: string;
  /** Room identifier of the appointment. */
  locationRoomId?: string;
  /** ID of the specialist. */
  specialistId: number;
  /** First and last name of the specialist. */
  specialistName: string;
  /** The translated specialist's title. */
  specialistTitle: string;
  /** Rating of the specialist if permitted to show. */
  specialistRating?: number;
  /** Whether or not the specialist allows new Kela clients (defaults to true) */
  specialistAllowsNewKelaClients?: boolean;
  /** Is the practitioner resource list (RNRO = 50). */
  isResourceList?: boolean;
  /** Does the practitioner have flexible worklist. */
  hasFlexibleScheduleOptions?: boolean;
  /**
   * A media.mehilainen.fi resource.
   * @example "945979dbf6854066f9e2b19262e8909d.jpg"
   */
  image: string | null;
  /**
   * All possible types of the appointment
   * @example ["clinic","video","phone"]
   */
  appointmentTypes: ("video" | "phone" | "clinic" | "callback")[];
  /** Pointer to the appointment in the dx_aika table (DH). */
  appointmentId?: number;
  /** Appointment search result (AssisDent). */
  assisDentSearchResult?: AssisDentSearchResult;
  /** DEPRECATED: Is the specialist a team member of primary OHC team */
  isPrimaryOHCSpecialist?: boolean;
  /** Is the specialist a team member of primary OHC team, undefined if not */
  primarySpecialistRole?:
    | "TTL"
    | "TTH"
    | "TFT"
    | "TPSY"
    | "YLEL"
    | "RATE"
    | "SOSSU";
  /** Id of the connection that found the appointment. */
  connectionId?: string;
  /** Id of the potential modal shown when clicking the appointment. */
  modalId?: string;
  /** Appointment kind (eg. 'VAST', 'SOIT') for MDAV */
  appointmentKind?: string;
  /** Etns for MDAV and AV */
  etns?: string;
  /** Etns for AV */
  etnsA?: string;
  /** Etns for AV */
  etnsB?: string;
  /**
   * Available duration options for flexible schedule appointments (in minutes).
   * Only populated for appointments with flexible schedules.
   * @example [30,45,60]
   */
  availableDurations?: number[];
  /** Is appointment a web appointment. */
  isWebAppointment?: boolean;
}

export interface SearchAppointmentSuggestion {
  type: "location" | "node" | "date";
  id: string;
  title: string;
  /** @format date-time */
  date?: string;
}

export interface SearchNodeAppointmentResults {
  daysInFuture?: number;
  modals?: ModalWithContractConditions[];
  appointments: AppointmentSearchResult[];
  suggestions: SearchAppointmentSuggestion[] | null;
  hasMoreData: boolean;
}

export interface QuickSearchBody {
  /**
   * Time ranges to filter results by.
   * @uniqueItems true
   * @example ["morning","afternoon","evening"]
   */
  timeRanges?: TimeRange[];
  /** @default "fi" */
  lang?: SupportedLanguage;
  /** Gender to filter specialists by. */
  gender?: Gender;
  /**
   * Appointment types to return.
   * @example ["video","phone"]
   */
  appointmentTypes?: AppointmentType[];
  /**
   * Guid of the node used for searching.
   * @format uuid
   */
  id: string;
  /**
   * Startdate for the search.
   * @format date-time
   */
  startDate: string;
  /**
   * @min 1
   * @max 6
   */
  nroOfMonths?: number;
  /**
   * Locations to filter results by.
   * @minItems 1
   * @example ["city2","clinic338"]
   */
  locationIds: string[];
  /**
   * LocationIds converted to internal location ids.
   * @example ["B-11","DOC","E-99","F-21"]
   */
  internalLocationIds?: string[];
  timeRange?: TimeRangeInput;
  durations?: number[];
  /** Patient age group ID to filter specialists by. */
  patientAgeGroupId?: number;
  /** Language ID to filter specialists by. */
  languageId?: number;
  /**
   * Insurance contract ID (Palveluhaku) to filter appointments by.
   * @example 1
   */
  insuranceContractId?: number;
  /** Is this OHC appointment search? */
  isOHC?: boolean;
  offset?: number;
  /** @format uuid */
  permitId?: string;
  /** @min 0 */
  minIntervalMinutes?: number;
  /**
   * @min 1
   * @max 20
   */
  maxResults?: number;
  useContractArea?: boolean;
}

export interface QuickSearchAppointment {
  /** Is the appointment covered by the OHC contract */
  isCoveredByOHC?: ContractRuleStatus;
  /**
   * Date and time of the appointment.
   * @format date-time
   */
  time: string;
  /** Duration of the appointment in minutes. */
  duration: number;
  /** Location of the appointment. */
  location: string;
  /** Numeric ID of the location. */
  locationId?: number;
  /** Translated name of the location. */
  locationName: string;
  locationShortName?: string;
  /** Translated location address. */
  locationAddress: string;
  /** Room identifier of the appointment. */
  locationRoomId?: string;
  /** ID of the specialist. */
  specialistId: number;
  /** First and last name of the specialist. */
  specialistName: string;
  /** The translated specialist's title. */
  specialistTitle: string;
  /** Rating of the specialist if permitted to show. */
  specialistRating?: number;
  /** Whether or not the specialist allows new Kela clients (defaults to true) */
  specialistAllowsNewKelaClients?: boolean;
  /** Is the practitioner resource list (RNRO = 50). */
  isResourceList?: boolean;
  /** Does the practitioner have flexible worklist. */
  hasFlexibleScheduleOptions?: boolean;
  /**
   * A media.mehilainen.fi resource.
   * @example "945979dbf6854066f9e2b19262e8909d.jpg"
   */
  image: string | null;
  /**
   * All possible types of the appointment
   * @example ["clinic","video","phone"]
   */
  appointmentTypes: ("video" | "phone" | "clinic" | "callback")[];
  /** Pointer to the appointment in the dx_aika table (DH). */
  appointmentId?: number;
  /** Appointment search result (AssisDent). */
  assisDentSearchResult?: AssisDentSearchResult;
  /** DEPRECATED: Is the specialist a team member of primary OHC team */
  isPrimaryOHCSpecialist?: boolean;
  /** Is the specialist a team member of primary OHC team, undefined if not */
  primarySpecialistRole?:
    | "TTL"
    | "TTH"
    | "TFT"
    | "TPSY"
    | "YLEL"
    | "RATE"
    | "SOSSU";
  /** Id of the connection that found the appointment. */
  connectionId?: string;
  /** Id of the potential modal shown when clicking the appointment. */
  modalId?: string;
  /** Appointment kind (eg. 'VAST', 'SOIT') for MDAV */
  appointmentKind?: string;
  /** Etns for MDAV and AV */
  etns?: string;
  /** Etns for AV */
  etnsA?: string;
  /** Etns for AV */
  etnsB?: string;
  /**
   * Available duration options for flexible schedule appointments (in minutes).
   * Only populated for appointments with flexible schedules.
   * @example [30,45,60]
   */
  availableDurations?: number[];
  /** Is appointment a web appointment. */
  isWebAppointment?: boolean;
  parseLink?: string;
}

export interface QuickSearchResult {
  appointments: QuickSearchAppointment[];
}

export interface NodeSearchSuggestionsParams {
  /** Types of suggestions to search for. */
  types: SearchAppointmentSuggestionType[];
  /**
   * Dates after which to search for date suggestions.
   * @format date-time
   */
  datesAfter?: string;
  /** The params to search suggestions for. */
  nodeSearch: SearchNodeAppointmentsParams;
}

export interface CalendarSearchResult {
  /**
   * Date of appointment availability.
   * @format date-time
   * @example "2021-02-25"
   */
  date: string;
  /**
   * Status of availability for the given date.
   * @example true
   */
  isAvailable: boolean;
  /**
   * Callbacks (= 'SOIT') for the given date.
   * @example true
   */
  hasCallbackSlots?: boolean;
  /**
   * Holiday status for the given date (MDAV clients only).
   * @example true
   */
  isHoliday?: boolean;
  /**
   * Weekday status for the given date (MDAV clients only).
   * @example true
   */
  isWeekday?: boolean;
  /**
   * Holiday description for the given date (MDAV clients only).
   * @example "Itsenäisyyspäivä"
   */
  holidayDescription?: string | null;
}

export interface AppointmentSearchByPractitionerParams {
  /** @default "fi" */
  lang?: SupportedLanguage;
  /**
   * Appointment types to return.
   * Defaults to [CLINIC, VIDEO, PHONE] if not provided.
   * @uniqueItems true
   * @default ["clinic","video","phone"]
   * @example ["video","phone"]
   */
  appointmentTypes: AppointmentType[];
  /**
   * Time ranges to filter results by.
   * @uniqueItems true
   * @example ["morning","afternoon","evening"]
   */
  timeRanges?: TimeRange[];
  /** Id of the practitioner for whom to search appointments for. */
  practitionerId: number;
  /**
   * Date for the search.
   * @format date-time
   */
  startDate: string;
  /**
   * Locations to filter results by.
   * @minItems 1
   * @uniqueItems true
   * @example ["clinic30","clinic338"]
   */
  location?: string[];
  /** Duration of appointments to search for. */
  duration?: number;
  /**
   * Search by multiple durations.
   * @minItems 1
   */
  durations?: number[];
  /**
   * Palveluhaku palvelu id.
   * Used to filter flexible schedule searches.
   */
  serviceId?: number;
  timeRange?: TimeRangeInput;
  isOhc?: boolean;
  /** @format uuid */
  nodeId?: string;
  /** @format uuid */
  reasonId?: string;
  /**
   * Number of days in future to search for appointments.
   * Requires 'amount' to be set if over 31.
   * @min 0
   * @max 180
   */
  daysInFuture?: number;
}

export interface PractitionerSearchResult {
  appointments: AppointmentSearchResult[];
  suggestions: SearchAppointmentSuggestion[] | null;
}

export interface CallbackSearchByPractitionerParams {
  /** @default "fi" */
  lang?: SupportedLanguage;
  /** Practitioner id. */
  practitionerId: number;
  /**
   * Date for the search.
   * @format date-time
   */
  startDate: string;
  /**
   * Number of days in future to search for appointments.
   * Requires 'amount' to be set if over 31.
   * @min 0
   * @max 180
   */
  daysInFuture?: number;
}

export interface CallbackSearchResult {
  /** Is the appointment covered by the OHC contract */
  isCoveredByOHC?: ContractRuleStatus;
  /**
   * Date and time of the appointment.
   * @format date-time
   */
  time: string;
  /** Duration of the appointment in minutes. */
  duration: number;
  /** Location of the appointment. */
  location: string;
  /** Numeric ID of the location. */
  locationId?: number;
  /** Translated name of the location. */
  locationName: string;
  locationShortName?: string;
  /** Translated location address. */
  locationAddress: string;
  /** Room identifier of the appointment. */
  locationRoomId?: string;
  /** ID of the specialist. */
  specialistId: number;
  /** First and last name of the specialist. */
  specialistName: string;
  /** The translated specialist's title. */
  specialistTitle: string;
  /** Rating of the specialist if permitted to show. */
  specialistRating?: number;
  /** Whether or not the specialist allows new Kela clients (defaults to true) */
  specialistAllowsNewKelaClients?: boolean;
  /** Is the practitioner resource list (RNRO = 50). */
  isResourceList?: boolean;
  /** Does the practitioner have flexible worklist. */
  hasFlexibleScheduleOptions?: boolean;
  /**
   * A media.mehilainen.fi resource.
   * @example "945979dbf6854066f9e2b19262e8909d.jpg"
   */
  image: string | null;
  /**
   * All possible types of the appointment
   * @example ["clinic","video","phone"]
   */
  appointmentTypes: ("video" | "phone" | "clinic" | "callback")[];
  /** Pointer to the appointment in the dx_aika table (DH). */
  appointmentId?: number;
  /** Appointment search result (AssisDent). */
  assisDentSearchResult?: AssisDentSearchResult;
  /** DEPRECATED: Is the specialist a team member of primary OHC team */
  isPrimaryOHCSpecialist?: boolean;
  /** Is the specialist a team member of primary OHC team, undefined if not */
  primarySpecialistRole?:
    | "TTL"
    | "TTH"
    | "TFT"
    | "TPSY"
    | "YLEL"
    | "RATE"
    | "SOSSU";
  /** Id of the connection that found the appointment. */
  connectionId?: string;
  /** Id of the potential modal shown when clicking the appointment. */
  modalId?: string;
  /** Appointment kind (eg. 'VAST', 'SOIT') for MDAV */
  appointmentKind?: string;
  /** Etns for MDAV and AV */
  etns?: string;
  /** Etns for AV */
  etnsA?: string;
  /** Etns for AV */
  etnsB?: string;
  /**
   * Available duration options for flexible schedule appointments (in minutes).
   * Only populated for appointments with flexible schedules.
   * @example [30,45,60]
   */
  availableDurations?: number[];
  /** Is appointment a web appointment. */
  isWebAppointment?: boolean;
}

export interface PractitionerCallbackSearchResult {
  appointments: CallbackSearchResult[];
}

export interface AppointmentPriceParams {
  /** @default "fi" */
  lang?: SupportedLanguage;
  /**
   * The appointment ID. Either DH PTR as a number or internal AssisDent id as a string.
   * @example 1234
   */
  appointmentId: string | number;
  /** @format date-time */
  date: string;
  /** @format uuid */
  nodeId?: string;
  /** @format uuid */
  connectionId?: string;
  /** @deprecated */
  specialtyId?: number;
  serviceId?: number;
  duration?: number;
  specialtyIds?: number[];
}

export interface AppointmentPrice {
  source: ElectronicHealthRecordSystem;
  appointmentType: "video" | "phone" | "clinic" | "callback";
  price: number;
  priceAfterKelaCompensation?: number;
  minPrice: number | null;
  maxPrice: number | null;
  minPriceAfterKelaCompensation: number | null;
  maxPriceAfterKelaCompensation: number | null;
  pricingInfo?: string;
  pricingInfoRows?: string;
}

export interface InsurancePayerOption {
  listing: InsurancePaymentOptionListing;
  id: string;
  name: string;
  description: string | null;
  /** @format uuid */
  redirectNodeId: string | null;
  additionalInfoForm: string | null;
  incidentType: string | null;
  /** @format uuid */
  fallbackPaymentOption: string | null;
  bookingInstructions: string | null;
}

export interface InsuranceCompany {
  id: number;
  name: string;
  bookingInstructions: string | null;
  insurancePayerOptions: InsurancePayerOption[];
  display_group?: number;
}

export interface I18N {
  fi: string;
  sv: string;
  en: string;
}

export interface GetDirectCompensationPermitsResult {
  id: string;
  i18n: {
    title: I18N;
    subtitle: I18N;
    subtitle2: I18N;
    htmlContent?: I18N;
  };
}

export interface GetCustomershipResult {
  hasCustomership: boolean;
  hasPolicyForClaimType: boolean;
  i18n?: {
    failedTitle: I18N;
    failedText: I18N;
  };
}

export interface UserDataForPermit {
  id: string;
  required: boolean;
}

export interface GetOptionsResult {
  id: string;
  icon: string;
  termsUpdated: string | null;
  isTermsAvailable: boolean;
  checkCustomership: boolean;
  userDataForPermit: UserDataForPermit[];
  needsDirectCompensationPermit: boolean;
  clientType: string;
  infoMehiList: object[];
  checkCustomershipUrl: string;
  i18n: {
    name: I18N;
    terms: I18N | null;
    termsTitle: I18N;
    termsCheckbox: I18N;
    agreementText: I18N;
    completedTitle: I18N;
    completedText: I18N;
    completedButton: I18N;
    checkCustomershipTitle: I18N;
    checkCustomershipText: I18N;
    checkCustomershipTextLinkLabels: I18N[];
    checkCustomershipCheckboxText: I18N;
    checkCustomershipButton: I18N;
    usingServiceCheckCustomerShipTitle: I18N;
    usingServiceCheckCustomerShipText: I18N;
    usingServiceCheckCustomerShipCheckBoxText: I18N;
    usingServiceCheckCustomerShipInfoText: I18N;
    usingServiceCheckCustomerShipInfoLinkText: I18N;
  };
}

export interface ConceptConsentStatus {
  showConsentSection: boolean;
  hasActiveConsent?: boolean;
}

export interface UserWithDelegateRole {
  isDelegateUser: boolean;
  id: number;
  fullName: string;
  firstName: string;
  lastName: string;
  ssn: string;
  /** @format email */
  email: string;
  phone: string;
  marketingPermits?: MarketingPermits;
  serviceMessagePermit?: boolean;
  hasAddress: boolean;
  address?: Address;
  omUid: number;
  employeeId?: number;
  companyName?: string;
  isOnlineReservationRestricted?: boolean;
}

export interface SessionInitParams {
  token: string;
}

export interface Service {
  type: string;
  id: object;
}

export interface SessionInitParamsAV2 {
  /** @format base64 */
  userData?: string;
  service?: Service;
  locations?: string;
  language?: string;
  sourceService?: string;
}

export interface AuthorizedPerson {
  omUid: number;
  firstName: string;
  lastName: string;
}

export interface User {
  id: number;
  fullName: string;
  firstName: string;
  lastName: string;
  ssn: string;
  /** @format email */
  email: string;
  phone: string;
  marketingPermits?: MarketingPermits;
  serviceMessagePermit?: boolean;
  hasAddress: boolean;
  address?: Address;
  omUid: number;
  employeeId?: number;
  companyName?: string;
  isOnlineReservationRestricted?: boolean;
}

export interface OmFeatureModalAction {
  action: "close" | "continue" | "digital_clinic" | "node" | "url";
  appearance: "primary" | "secondary" | "tertiary";
  /** @format uri */
  url?: string;
  i18n: {
    title: I18N;
  };
}

export interface OmFeatureModal {
  actions: OmFeatureModalAction[];
  i18n: {
    title: I18N;
    description: I18N;
  };
}

export interface OmFeatureMetadata {
  /** @format uri */
  url?: string;
  serviceId?: string;
  prescriptionId?: string;
  detailType?: string;
  customerType?: string;
  serviceType?: string;
  redirectType?: string;
  actionId?: string;
}

export interface OmFeatureForUser {
  type: "private" | "tep" | "insurance" | "health_contract";
  icon: string | null;
  width: "small" | "large";
  modal?: OmFeatureModal | null;
  action:
    | "asiointi-detail"
    | "asiointi-service"
    | "asiointi-tep"
    | "book-appointment-url"
    | "digital-clinic-service"
    | "digital-clinic-payer-selection"
    | "renew-prescription"
    | "select-insurance-company"
    | "view-customer-service-detail";
  metadata: OmFeatureMetadata;
  i18n: {
    title: I18N;
  };
}

export interface AppointmentLockParams {
  appointmentId: number;
  duration?: number;
  /**
   * @min 300
   * @max 1800
   */
  lockLength?: number;
  /** @format uuid */
  nodeId?: string;
  serviceId?: number;
}

export interface AppointmentLockResult {
  appointmentIds: number[];
  /** @format date-time */
  endDateTime: string;
}

export interface AppointmentUnlockParams {
  /** @uniqueItems true */
  appointmentIds: number[];
}

export interface PractitionerData {
  /** Whether the practitioner has the selected insurance contract. Only set when insuranceContractId query param is provided. */
  hasInsuranceContract?: boolean;
  id: number;
  title: string | null;
  image: string | null;
  privateOnly: boolean;
}

export interface SearchKeywordData {
  id: string;
  numNodes: number;
  nodes: string[];
  keywordServiceType: "private" | "ohc" | "both";
}

export interface NodeData {
  id: string;
  numChildren: number;
  weight: number;
  serviceType: "private" | "ohc" | "both" | null;
  icon?: string;
}

export interface NodeAutocompleteResult {
  keyword: string;
  practitionerData?: PractitionerData;
  searchKeywordData?: SearchKeywordData;
  nodeData?: NodeData;
  groupData?: NodeAutocompleteResult[];
}

export interface NodeAutocompleteResultWithContract {
  /** @example "allowed" */
  contractRuleStatus?: ContractRuleStatus;
  keyword: string;
  practitionerData?: PractitionerData;
  searchKeywordData?: SearchKeywordData;
  nodeData?: NodeData;
  groupData?: NodeAutocompleteResult[];
}

export interface LocationAutocompleteResult {
  type: "all" | "city" | "region" | "clinic";
  id: number;
  clinicIDs: string[];
  name: string;
  address: string | null;
  phone: string | null;
  imageUrl: string | null;
  lat: number | null;
  long: number | null;
  clinicType: string;
  priority: number;
  favorite: boolean;
  locationTypes: number[];
  supported?: boolean;
}

export interface ParseBodyParams {
  /** @format base64 */
  userData?: string;
  envelope?: string;
  token?: string;
  sourceService?: "APP" | "OM" | "MDAV" | "MDAV_DH_NAPPI" | "MDAV_DH_VIDEO";
  language?: "fi" | "en" | "sv";
  campaignString?: string;
  selectedOmUid?: number;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Mehiläinen AV API
 * @version 97.7.0
 * @contact
 *
 * Mehiläinen Ajanvaraus API:n kuvaus
 */
export class Api<
  SecurityDataType extends unknown,
  IHttpClient extends HttpClient<SecurityDataType>,
> {
  http: IHttpClient;

  constructor(http: IHttpClient) {
    this.http = http;
  }

  v1 = {
    /**
     * No description
     *
     * @tags public
     * @name GetLocations
     * @request GET:/v1/public/locations
     */
    getLocations: (
      query: {
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<LocationResult[], any>({
        path: `/v1/public/locations`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name GetGeolocateResults
     * @request GET:/v1/public/locations/geolocate
     */
    getGeolocateResults: (
      query: {
        lang: "fi" | "en" | "sv";
        lat: number;
        long: number;
        /** @deprecated */
        acceptedLocationTypes?: number[];
        /** @format uuid */
        nodeId?: string;
        isOHC?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<LocationResult[], any>({
        path: `/v1/public/locations/geolocate`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name GetLanguages
     * @request GET:/v1/public/languages
     */
    getLanguages: (
      query: {
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<LanguageResult[], any>({
        path: `/v1/public/languages`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name GetAgeGroups
     * @request GET:/v1/public/age-groups
     */
    getAgeGroups: (
      query: {
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PatientAgeGroup[], any>({
        path: `/v1/public/age-groups`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name GetPractitionerDetails
     * @request GET:/v1/public/practitioner-details
     */
    getPractitionerDetails: (
      query: {
        lang?: SupportedLanguage;
        practitionerId: number;
        isOhc?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PractitionerDetails, any>({
        path: `/v1/public/practitioner-details`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name Translations
     * @request GET:/v1/public/translations
     */
    translations: (params: RequestParams = {}) =>
      this.http.request<object, any>({
        path: `/v1/public/translations`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name GetNotifications
     * @request GET:/v1/public/notifications
     */
    getNotifications: (
      query: {
        lang: string;
        locations: string[];
        nodeId: string;
        isOHC: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SimpleNotification[], any>({
        path: `/v1/public/notifications`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name GetDkNotifications
     * @request GET:/v1/public/digitalclinic-notifications
     */
    getDkNotifications: (
      query: {
        lang: string;
        locations: string[];
        nodeId: string;
        isOHC: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DCNotification[], any>({
        path: `/v1/public/digitalclinic-notifications`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name GetServiceName
     * @request GET:/v1/public/service-name
     */
    getServiceName: (
      query: {
        lang: string;
        serviceId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<ServiceDetails, any>({
        path: `/v1/public/service-name`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name GetBookingInstructions
     * @request GET:/v1/public/booking-instructions
     */
    getBookingInstructions: (
      query: {
        lang: string;
        serviceId?: number;
        nodeId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<BookingInstructions | null, any>({
        path: `/v1/public/booking-instructions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ohc
     * @name GetContract
     * @request GET:/v1/ohc/contract
     */
    getContract: (params: RequestParams = {}) =>
      this.http.request<object, any>({
        path: `/v1/ohc/contract`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ohc
     * @name GetContractDates0
     * @request GET:/v1/ohc/contract-dates
     */
    getContractDates0: (params: RequestParams = {}) =>
      this.http.request<ContractUsePeriods, any>({
        path: `/v1/ohc/contract-dates`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ohc
     * @name GetContractDates1
     * @request GET:/v1/ohc/contract-info
     */
    getContractDates1: (params: RequestParams = {}) =>
      this.http.request<ContractUsePeriods, any>({
        path: `/v1/ohc/contract-info`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ohc
     * @name GetOhcLocations
     * @request GET:/v1/ohc/locations
     */
    getOhcLocations: (
      query: {
        lang: string;
        nodeId: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<LocationResult[], any>({
        path: `/v1/ohc/locations`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ohc
     * @name IsPricingItemCoveredByContract
     * @request GET:/v1/ohc/contract-coverage
     */
    isPricingItemCoveredByContract: (
      query: {
        employeeId?: number;
        companyId?: number;
        type: "hinnastoryhma" | "hinnastokoodi";
        value: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, any>({
        path: `/v1/ohc/contract-coverage`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings
     * @name FeatureFlags
     * @request GET:/v1/settings/feature-flags
     */
    featureFlags: (params: RequestParams = {}) =>
      this.http.request<FeatureFlag[], any>({
        path: `/v1/settings/feature-flags`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags search-nodes
     * @name SearchNode
     * @request GET:/v1/search-nodes
     */
    searchNode: (
      query?: {
        lang?: SupportedLanguage;
        /** @format uuid */
        nodeId?: string;
        /** @format uuid */
        keywordId?: string;
        /**
         * @minLength 3
         * @maxLength 128
         */
        keyword?: string;
        isOhc?: boolean;
        onlyListed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SearchNodeWithModals[] | PublicNode[], any>({
        path: `/v1/search-nodes`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags search-nodes
     * @name FavoriteNodes
     * @request GET:/v1/search-nodes/favorites
     */
    favoriteNodes: (
      query: {
        menu: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SearchNodeWithModals[] | PublicNode[], any>({
        path: `/v1/search-nodes/favorites`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags search-nodes
     * @name SearchNodes
     * @request GET:/v1/search-nodes/listed
     */
    searchNodes: (
      query: {
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PublicNode[], any>({
        path: `/v1/search-nodes/listed`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags search-nodes
     * @name AllNodes
     * @request GET:/v1/search-nodes/all
     */
    allNodes: (
      query: {
        lang: string;
        isOhc: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SearchNodeWithModals[] | PublicNode[], any>({
        path: `/v1/search-nodes/all`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags search-nodes
     * @name SearchNodeLinkings
     * @request GET:/v1/search-nodes/linkings
     */
    searchNodeLinkings: (params: RequestParams = {}) =>
      this.http.request<SearchNodeLinking[], any>({
        path: `/v1/search-nodes/linkings`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags search-nodes
     * @name GetOhcNodes
     * @request GET:/v1/search-nodes/ohc/listed
     */
    getOhcNodes: (
      query: {
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PublicNode[], any>({
        path: `/v1/search-nodes/ohc/listed`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags modals
     * @name GetModals
     * @request GET:/v1/modals
     */
    getModals: (
      query: {
        lang: string;
        isOHC: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<Modal[], any>({
        path: `/v1/modals`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reservations
     * @name Reserve
     * @request POST:/v1/reservations
     */
    reserve: (data: ReserveParams, params: RequestParams = {}) =>
      this.http.request<ReserveResult, any>({
        path: `/v1/reservations`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reservations
     * @name CancelAppointment
     * @request DELETE:/v1/reservations
     */
    cancelAppointment: (
      data: CancelAppointmentParams,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/v1/reservations`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags reservations
     * @name CancellationInfo
     * @request GET:/v1/reservations/cancellation-info
     */
    cancellationInfo: (
      query: {
        lang?: SupportedLanguage;
        reservationId: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<CancellationInfo, any>({
        path: `/v1/reservations/cancellation-info`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reservations
     * @name ReservationInfo
     * @request GET:/v1/reservations/reservation-info
     */
    reservationInfo: (
      query: {
        reservationId: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<AppointmentReservationInfo, any>({
        path: `/v1/reservations/reservation-info`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reservations
     * @name NotificationInfo
     * @request GET:/v1/reservations/notification-info
     */
    notificationInfo: (
      query: {
        appointmentId: UUIDOrIntPipeResult;
        action: string;
        userPid: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, any>({
        path: `/v1/reservations/notification-info`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reservations
     * @name ReservationPaymentTypes
     * @request GET:/v1/reservations/reservation-payment-types
     */
    reservationPaymentTypes: (
      query: {
        /** The appointment ID. Either DH PTR or internal AssisDent id as a string. */
        appointmentId: string;
        isOhc?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<ReservationPaymentTypesResponse, any>({
        path: `/v1/reservations/reservation-payment-types`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reservations
     * @name CallbackReserveAllowed
     * @request POST:/v1/reservations/callback-reserve-allowed
     */
    callbackReserveAllowed: (
      data: CallbackReservationAllowedParams,
      params: RequestParams = {},
    ) =>
      this.http.request<CallbackAllowedResponse, any>({
        path: `/v1/reservations/callback-reserve-allowed`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reservations
     * @name GetReservationDestinationSystem
     * @request GET:/v1/reservations/reservation-destination-system
     */
    getReservationDestinationSystem: (
      query: {
        nodeId?: string;
        serviceId?: number;
        appointmentId: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<ReservationDestinationSystemResult, any>({
        path: `/v1/reservations/reservation-destination-system`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name AppointmentInfo
     * @request GET:/v1/appointments
     */
    appointmentInfo: (
      query: {
        lang?: SupportedLanguage;
        /** The appointment ID. Either DH PTR or internal AssisDent id as a string. */
        appointmentId: string;
        /** @format uuid */
        nodeId?: string;
        /** @format uuid */
        connectionId?: string;
        isOHC?: boolean;
        duration?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<AppointmentInfoResult, any>({
        path: `/v1/appointments`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name GetAppointmentLengthOptions
     * @request GET:/v1/appointments/appointment-length-options
     */
    getAppointmentLengthOptions: (
      query: {
        lang?: SupportedLanguage;
        appointmentId: number;
        /** @format uuid */
        nodeId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<AppointmentLengthOption[], any>({
        path: `/v1/appointments/appointment-length-options`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name GetFlexibleAppointmentLengthOptions
     * @request GET:/v1/appointments/flexible-appointment-options
     */
    getFlexibleAppointmentLengthOptions: (
      query: {
        practitionerId: number;
        locationId: number;
        /** @format uuid */
        nodeId?: string;
        serviceId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<AppointmentLengthOption[], any>({
        path: `/v1/appointments/flexible-appointment-options`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name NodeAppointmentSearch
     * @request POST:/v1/appointments/search
     */
    nodeAppointmentSearch: (
      data: SearchNodeAppointmentsParams,
      params: RequestParams = {},
    ) =>
      this.http.request<SearchNodeAppointmentResults, any>({
        path: `/v1/appointments/search`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name QuickSearch
     * @request POST:/v1/appointments/search/quick/{path}
     */
    quickSearch: (
      path: string,
      data: QuickSearchBody,
      query?: {
        erikoisala?: string;
        palvelu?: string;
        paid?: string;
        oaid?: string;
        alapalvelu?: string;
        treatment?: string;
        parse_key?: string;
        location?: string;
        wloc?: string;
        laakari?: string;
        lkri?: string;
        date?: string;
        remote?: string;
        appointment_types?: string;
        insurance?: string;
        language?: "fi" | "en" | "sv";
        od?: string;
        tt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<QuickSearchResult, any>({
        path: `/v1/appointments/search/quick/${path}`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name NodeSearchSuggestions
     * @request POST:/v1/appointments/search/suggestions
     */
    nodeSearchSuggestions: (
      data: NodeSearchSuggestionsParams,
      params: RequestParams = {},
    ) =>
      this.http.request<SearchAppointmentSuggestion[], any>({
        path: `/v1/appointments/search/suggestions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name NodeSearchCalendar
     * @request POST:/v1/appointments/search/calendar
     */
    nodeSearchCalendar: (
      data: SearchNodeAppointmentsParams,
      params: RequestParams = {},
    ) =>
      this.http.request<CalendarSearchResult[], any>({
        path: `/v1/appointments/search/calendar`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name AvailablePractitionersSearch
     * @request POST:/v1/appointments/search/available-practitioners
     */
    availablePractitionersSearch: (
      data: SearchNodeAppointmentsParams,
      params: RequestParams = {},
    ) =>
      this.http.request<AppointmentSearchResult[], any>({
        path: `/v1/appointments/search/available-practitioners`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name PractitionerAppointmentSearch
     * @request POST:/v1/appointments/search/practitioner
     */
    practitionerAppointmentSearch: (
      data: AppointmentSearchByPractitionerParams,
      params: RequestParams = {},
    ) =>
      this.http.request<PractitionerSearchResult, any>({
        path: `/v1/appointments/search/practitioner`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name PractitionerAppointmentSearchCalendar
     * @request POST:/v1/appointments/search/practitioner/calendar
     */
    practitionerAppointmentSearchCalendar: (
      data: AppointmentSearchByPractitionerParams,
      params: RequestParams = {},
    ) =>
      this.http.request<CalendarSearchResult[], any>({
        path: `/v1/appointments/search/practitioner/calendar`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name PractitionerCallbackSearch
     * @request POST:/v1/appointments/search/practitioner/callback
     */
    practitionerCallbackSearch: (
      data: CallbackSearchByPractitionerParams,
      params: RequestParams = {},
    ) =>
      this.http.request<PractitionerCallbackSearchResult, any>({
        path: `/v1/appointments/search/practitioner/callback`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name PractitionerCallbackSearchCalendar
     * @request POST:/v1/appointments/search/practitioner/callback/calendar
     */
    practitionerCallbackSearchCalendar: (
      data: CallbackSearchByPractitionerParams,
      params: RequestParams = {},
    ) =>
      this.http.request<CalendarSearchResult[], any>({
        path: `/v1/appointments/search/practitioner/callback/calendar`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name GetNodeFlexibleSearchOptions
     * @request GET:/v1/appointments/flexible-search-options
     */
    getNodeFlexibleSearchOptions: (
      query: {
        nodeId: string;
        locations: string[];
      },
      params: RequestParams = {},
    ) =>
      this.http.request<number[], any>({
        path: `/v1/appointments/flexible-search-options`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name AppointmentPrice
     * @request POST:/v1/appointments/appointment-price
     */
    appointmentPrice: (
      data: AppointmentPriceParams,
      params: RequestParams = {},
    ) =>
      this.http.request<AppointmentPrice[], any>({
        path: `/v1/appointments/appointment-price`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags insurance
     * @name InsuranceCompanies
     * @request GET:/v1/insurance/companies
     */
    insuranceCompanies: (
      query: {
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<InsuranceCompany[], any>({
        path: `/v1/insurance/companies`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags insurance
     * @name InsuranceDirectCompensationPermits
     * @request GET:/v1/insurance/direct-compensation-permits
     */
    insuranceDirectCompensationPermits: (
      query: {
        subjectOmUid: number;
        insuranceCompanyId: string;
        lang: string;
        /** Type of incident for insurance claim. May be undefined. */
        incidentType?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<GetDirectCompensationPermitsResult[], any>({
        path: `/v1/insurance/direct-compensation-permits`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags insurance
     * @name InsuranceCustomership
     * @request GET:/v1/insurance/customership
     */
    insuranceCustomership: (
      query: {
        subjectOmUid: number;
        insuranceCompanyId: string;
        lang: string;
        /** Type of incident for insurance claim. May be undefined. */
        incidentType?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<GetCustomershipResult, any>({
        path: `/v1/insurance/customership`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags insurance
     * @name InsuranceOptions
     * @summary Get insurance options information
     * @request GET:/v1/insurance/options
     */
    insuranceOptions: (
      query: {
        subjectOmUid: number;
        insuranceCompanyId: string;
        lang: string;
        /** Type of incident for insurance claim. May be undefined. */
        incidentType?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<GetOptionsResult, any>({
        path: `/v1/insurance/options`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags insurance
     * @name ConceptConsentStatus
     * @request GET:/v1/insurance/concept-consent-status
     */
    conceptConsentStatus: (
      query: {
        subjectOmUid: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<ConceptConsentStatus, any>({
        path: `/v1/insurance/concept-consent-status`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags insurance
     * @name SaveConceptConsent
     * @summary Save concept consent for insurance
     * @request POST:/v1/insurance/concept-consent
     */
    saveConceptConsent: (
      query: {
        subjectOmUid: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/v1/insurance/concept-consent`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name GetUser
     * @request GET:/v1/user
     */
    getUser: (params: RequestParams = {}) =>
      this.http.request<UserWithDelegateRole, any>({
        path: `/v1/user`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name InitsessionJwt
     * @request POST:/v1/user/init-session-jwt
     */
    initsessionJwt: (data: SessionInitParams, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/v1/user/init-session-jwt`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name InitSessionAv2
     * @request POST:/v1/user/init-session-av2
     */
    initSessionAv2: (data: SessionInitParamsAV2, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/v1/user/init-session-av2`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name Logout
     * @request POST:/v1/user/logout
     */
    logout: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/v1/user/logout`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name Heartbeat
     * @request POST:/v1/user/heartbeat
     */
    heartbeat: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/v1/user/heartbeat`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name Add
     * @request GET:/v1/user/authorizations/add
     */
    add: (
      query: {
        /** @format uri */
        origin: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/v1/user/authorizations/add`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name GetAuthorizations
     * @request GET:/v1/user/authorizations
     */
    getAuthorizations: (params: RequestParams = {}) =>
      this.http.request<AuthorizedPerson[], any>({
        path: `/v1/user/authorizations`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name GetPrincipalUser
     * @request GET:/v1/user/authorizations/principal/{omUid}
     */
    getPrincipalUser: (omUid: number, params: RequestParams = {}) =>
      this.http.request<User, any>({
        path: `/v1/user/authorizations/principal/${omUid}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name GetOmFeatures
     * @request GET:/v1/user/om-features
     */
    getOmFeatures: (params: RequestParams = {}) =>
      this.http.request<OmFeatureForUser[], any>({
        path: `/v1/user/om-features`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointment-locks
     * @name LockAppointment
     * @request POST:/v1/appointment-locks
     */
    lockAppointment: (
      data: AppointmentLockParams,
      params: RequestParams = {},
    ) =>
      this.http.request<AppointmentLockResult, any>({
        path: `/v1/appointment-locks`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointment-locks
     * @name UnlockAppointment
     * @request DELETE:/v1/appointment-locks
     */
    unlockAppointment: (
      data: AppointmentUnlockParams,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/v1/appointment-locks`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags autocomplete
     * @name AutocompleteNode
     * @request GET:/v1/autocomplete/node
     */
    autocompleteNode: (
      query: {
        searchString: string;
        lang: string;
        limit: number;
        ohc: boolean;
        insuranceContractId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        NodeAutocompleteResult[] | NodeAutocompleteResultWithContract[],
        any
      >({
        path: `/v1/autocomplete/node`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags autocomplete
     * @name AutocompleteLocation
     * @request GET:/v1/autocomplete/location
     */
    autocompleteLocation: (
      query: {
        searchString: string;
        lang: string;
        limit: number;
        ohc: boolean;
        nodeId: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<LocationAutocompleteResult[], any>({
        path: `/v1/autocomplete/location`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  v2 = {
    /**
     * No description
     *
     * @tags search-nodes-v2
     * @name AllOhcNodes
     * @request GET:/v2/search-nodes/all/ohc
     */
    allOhcNodes: (
      query: {
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SearchNodeWithModals[], any>({
        path: `/v2/search-nodes/all/ohc`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags search-nodes-v2
     * @name AllPrivateNodes
     * @request GET:/v2/search-nodes/all
     */
    allPrivateNodes: (
      query: {
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PublicNode[], any>({
        path: `/v2/search-nodes/all`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  parse = {
    /**
     * No description
     *
     * @tags parse
     * @name ParseGet
     * @request GET:/parse/{path}
     */
    parseGet: (
      path: string,
      query: {
        language: string;
        isRedirected: boolean;
        noLanding: boolean;
        envelope: string;
        token: string;
        sourceService: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/parse/${path}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags parse
     * @name ParsePost
     * @request POST:/parse/{path}
     */
    parsePost: (
      path: string,
      query: {
        language: string;
      },
      data: ParseBodyParams,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/parse/${path}`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
}
